import { render } from "./SectionAbout.vue?vue&type=template&id=8272f3d0&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"

import "./SectionAbout.vue?vue&type=style&index=0&id=8272f3d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8272f3d0"]])

export default __exports__